import { ParamValues } from '../../../../../components/Crud/useFilter.types';
import { downloadXlsx } from '../../../../xlsx/downloadXlsx';
import { OrderListTabName, getOrderStatusByTab } from '../../../list/orderListTabs';
import { formatOrderFilters } from '../../../orderFilter/orderFilter.utils';
import { ExportOrderScope } from '../ExportOrderModal.types';
import { mapCsvScope } from '../services/exportOrderScope';

const ORDER_MODEL_EXPORT_URL = 'orders-export/model/xlsx';

interface ExportOrderModelXlsxParams {
  exportScope: ExportOrderScope;
  fileName: string;
}

const resolveStatus = (
  searchParams: Record<string, unknown>,
  selectedTab?: OrderListTabName,
): unknown => {
  const status = searchParams.status ?? getOrderStatusByTab(selectedTab);
  const hasStatus = Array.isArray(status) ? status.length > 0 : Boolean(status);
  return hasStatus ? status : undefined;
};

export const exportOrderModelXlsx = ({
  exportScope,
  fileName,
}: ExportOrderModelXlsxParams): Promise<void> => {
  const searchParams = mapCsvScope(exportScope.scope);
  const searchParamsWithStatus = {
    ...searchParams,
    status: resolveStatus(searchParams, exportScope.selectedTab),
  };
  const filters = formatOrderFilters(searchParamsWithStatus) as ParamValues;

  return downloadXlsx({ url: ORDER_MODEL_EXPORT_URL, fileName, filters });
};
